const enum Category {
    NONE = 0,
    SUPER_ADMIN = 1,
    CADRE = 2,
    NIVEAU_1 = 3,
    NIVEAU_2 = 4
}

export default Category;